/* eslint-disable no-param-reassign */
import { fetchFavoriteArticleIds, addFavoriteArticle, removeFavoriteArticle } from '../memberApi';
import Cookie from '../../../shared/menuLogic/cookie';

export const initFavoriteButton = function () {
  const buttons = document.getElementsByClassName('save-article-button');
  const notAMemberModal = document.getElementById('not-a-member-modal');

  const drawFavoredButton = function (button) {
    button.innerHTML = `<img class="save-article-heart-icon" id="save-article-heart-icon" src="/view-resources/public/elle/images/filled-heart.svg" alt="Heart icon" />
    <span id="save-article-btn-text" class="save-article-btn-text">SPARAD ARTIKEL</span>`;
  };
  const drawUnfavoredButton = function (button) {
    button.innerHTML = `<img class="save-article-heart-icon" id="save-article-heart-icon" src="/view-resources/public/elle/images/heart-outlined-icon.svg" alt="Heart icon" />
    <span id="save-article-btn-text" class="save-article-btn-text">SPARA ARTIKEL</span>`;
  };

  document.addEventListener('loggedIn', async function () {
    const jwt = Cookie.get('login_token');

    const drawButtons = () => {
      Array.from(buttons).forEach(async (button) => {
        const article = button.closest('article');
        const articleId = article.dataset.id;
        const favoredArticles = await fetchFavoriteArticleIds(jwt);
        const alreadyFavored = favoredArticles.data.find((item) => {
          return item.articleId === articleId;
        });
        if (alreadyFavored) {
          drawFavoredButton(button);
          button.onclick = async () => {
              drawUnfavoredButton(button);
              document.getElementsByClassName('save-btn-sticky')[0].innerHTML = `
              <img class="save-article-heart-icon" id="save-article-heart-icon" src="/view-resources/public/elle/images/heart-outlined-icon-empty.svg" alt="Heart icon" />
              <span id="save-article-btn-text" class="save-article-btn-text">Spara<br>artikel</span>
              `;
              await removeFavoriteArticle(articleId, jwt);
              drawButtons();
          };
        } else {
          drawUnfavoredButton(button);
          button.onclick = async () => {
              drawFavoredButton(button);
              document.getElementsByClassName('save-btn-sticky')[0].innerHTML = `
              <img class="save-article-heart-icon" id="save-article-heart-icon" src="/view-resources/public/elle/images/heart-outlined-icon-filled.svg" alt="Heart icon" />
              <span id="save-article-btn-text" class="save-article-btn-text">Sparad<br>artikel</span>
              `;
              await addFavoriteArticle(articleId, jwt);
            if (window.cts) {
              cts.send.event('action', 'click', 'favorite-article|save|'+articleId);
            }
            drawButtons();
          };
        }
      });
    };
    drawButtons();
  });

  document.addEventListener('notLoggedIn', function () {
    Array.from(buttons).forEach((button) => {
      // Trigger Modal
      button.onclick = () => {
        notAMemberModal.classList.remove('hidden');
        document.body.style.overflow = 'hidden';
      };
    });
    // Hide modal
    if (notAMemberModal) {
      notAMemberModal.onclick = (modalClickEvent) => {
        if (
          modalClickEvent.target === notAMemberModal ||
          modalClickEvent.target === notAMemberModal.querySelector('.modal-close-icon')
        ) {
          notAMemberModal.classList.add('hidden');
          document.body.style.overflow = 'auto';
        }
      };
    }
  });
};
